import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, map, tap } from 'rxjs';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class JobfairService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadJobFairListInit() {
		this.ngrxService.loadInitAPI('job', 'fairs').subscribe();
	}
	loadJobFairListData() {
		return this.getjobfairList().pipe(
			map(data => this.ngrxService.loadInitData('job', 'fairs', data)),
		);
	}

	fetchJobFairListData() {
		return this.ngrxService.loadData('job', 'fairs');
	}

	updateJobFairListData(id: any, content: any) {
		this.ngrxService
			.loadData('job', 'fairs')
			.pipe(
				first(),
				map((data: any) => data.data),
				tap((data: any) => {
					let newData = data.data.map((jobfair: any) => {
						if (jobfair.id === id) {
							jobfair = content;
						}
						return jobfair;
					});

					this.ngrxService.loadInitData('job', 'fairs', {
						...data,
						data: newData,
					});
				}),
			)
			.subscribe();
		return this.updateJobfair(id, content);
	}

	getjobfairList() {
		return this.http.get(environment.url.company + '/all/jobfair/list').pipe(
			map((data: any) => {
				return {
					...data,
					data: data.data.sort(this.sortComparer),
				};
			}),
		);
	}
	getLocationList() {
		return this.http.get(environment.url.company + '/location').pipe(
			map((data: any) => {
				return {
					...data,
					data: data.sort(this.sortComparer),
				};
			}),
		);
	}
	getTimeZoneList() {
		return this.http.get(environment.url.company + '/jobfair/timeZone').pipe(
			map((data: any) => {
				return {
					...data,
					data: data.sort(this.sortComparer),
				};
			}),
		);
	}

	getJobFunctionList() {
		return this.http.get(environment.url.company + '/jobfair/function').pipe(
			map((data: any) => {
				return {
					...data,
					data: data.sort(this.sortComparer),
				};
			}),
		);
	}

	getPartnershipList() {
		return this.http.get(environment.url.company + '/all/company');
	}

	addJobfair(content: any) {
		return this.http
			.post(environment.url.company + '/jobfair', content, {})
			.pipe(
				tap(() => {
					this.loadJobFairListData().subscribe();
				}),
			);
	}

	updateJobfair(id: any, content: any) {
		return this.http.put(
			environment.url.company + `/jobfair/${id}/update`,
			content,
			{},
		);
	}

	sortComparer(a: any, b: any) {
		return b.jobFairDate - a.jobFairDate;
	}
}
